import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  ClientsListParams,
  NewClientsApiService,
  NewClientsResponse,
} from 'features/new-clients/api/new-clients-api.service';
import qs from 'qs';

import { NewClientsQueryKeys } from './query-keys';
const { getCustomizeAccess } = NewClientsApiService();

const getUsersQuery = (
  params: ClientsListParams,
  options?: UseQueryOptions<NewClientsResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<NewClientsResponse>;
  options?: UseQueryOptions<NewClientsResponse>;
} => ({
  queryKey: NewClientsQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getCustomizeAccess(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetSubCategoryCotmizeList = (
  params: ClientsListParams,
  options?: UseQueryOptions<NewClientsResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<NewClientsResponse, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
